import { FC } from 'react';
import { NetSuiteCustomersDropdown } from './NetSuiteCustomersDropdown';
import { NetSuiteLegacyInput } from './NetSuiteLegacyInput';

type NetSuiteCustomerInputProps = {
  showNetSuiteOptions: boolean;
};

export const NetSuiteCustomerInput: FC<NetSuiteCustomerInputProps> = ({ showNetSuiteOptions }) => (
  <>{showNetSuiteOptions ? <NetSuiteCustomersDropdown showDropdown={true} /> : <NetSuiteLegacyInput />}</>
);
